// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
export function deepEqual(a: any, b: any): boolean {
  if (a === b) return true;
  if (typeof a !== 'object' || typeof b !== 'object' || !a || !b) return false;

  const ak = Object.keys(a);
  const bk = Object.keys(b);
  if (ak.length !== bk.length) return false;

  return ak.every(k => deepEqual(a[k], b[k]));
}